import _classCallCheck from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _possibleConstructorReturn from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @format */

import React, { Component } from 'react';
import { memberProfilePropType, memberProfileDefaultProps } from "../../../constants/app";
import { Button, ArrowLink, ClickedOutside } from "../../_global";
import MarketingOptIn from "../../Account/Settings/MarketingOptIn";
import NewUserModal from "../../Account/Settings/NewUserModal";
import withMemberProfile from "../withMemberProfile";
import { Profile, ProfileDropdown, Info, Avatar, Name, Points, Detail, DetailSection, RememberMe, MemberName, LinkList, LinkItem, LastDetails, ProfileBlock, LoginButton } from "./style";
var handleLogoutClick = function handleLogoutClick() {
  window.location.href = '/logout';
};
var MemberProfile = /*#__PURE__*/function (_Component) {
  function MemberProfile() {
    var _this;
    _classCallCheck(this, MemberProfile);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _possibleConstructorReturn(_this, (_this = _callSuper(this, MemberProfile, [].concat(args)), _this.state = {
      showDetail: false
    }, _this.keyDownListener = function (e) {
      if (e.key === 'Escape' && _this.state.showModal) {
        _this.props.closeLoginModal();
      }
    }, _this.handleLoginClick = function () {
      _this.props.openLoginModal(window.location.href);
      _this.setState({
        showDetail: false
      });
      _this.props.removeAndSyncShoSession();
    }, _this.toggleDetail = function () {
      _this.setState({
        showDetail: !_this.state.showDetail
      });
    }, _this.closeDetail = function () {
      _this.setState({
        showDetail: false
      });
    }, _assertThisInitialized(_this)));
  }
  _inherits(MemberProfile, _Component);
  return _createClass(MemberProfile, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keydown', this.keyDownListener);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.authenticated !== nextProps.authenticated) {
        this.closeDetail();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.keyDownListener);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        authorized = _this$props.authorized,
        authenticated = _this$props.authenticated,
        firstName = _this$props.firstName,
        lastName = _this$props.lastName,
        points = _this$props.points,
        ffn = _this$props.ffn,
        visible = _this$props.visible,
        showOptIn = _this$props.showOptIn,
        showNewUserModal = _this$props.showNewUserModal,
        isMobileBrowser = _this$props.isMobileBrowser;
      var formattedPoints = parseInt(points, 10).toLocaleString();
      return __jsx(React.Fragment, null, __jsx(Profile, {
        visible: visible
      }, __jsx(ProfileDropdown, {
        active: this.state.showDetail
      }, (authorized || authenticated) && __jsx(Info, {
        className: this.state.showDetail && 'ignore-react-onclickoutside',
        onClick: this.toggleDetail,
        tabIndex: "0",
        showIndicator: authorized && !authenticated,
        isMobileBrowser: isMobileBrowser
      }, __jsx(Avatar, null, __jsx("svg", {
        width: "32px",
        height: "32px",
        viewBox: "0 0 32 32",
        version: "1.1"
      }, __jsx("g", {
        id: "Symbols",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, __jsx("g", {
        id: "Top-header",
        transform: "translate(-1254.000000, -14.000000)"
      }, __jsx("g", {
        id: "Group",
        transform: "translate(1255.000000, 15.000000)"
      }, __jsx("path", {
        id: "circle",
        d: "M0,15 C0,6.71572875 6.71390727,0 15,0 L15,0 C23.2842712,0 30,6.71390727 30,15 L30,15 C30,23.2842712 23.2860927,30 15,30 L15,30 C6.71572875,30 0,23.2860927 0,15 L0,15 Z",
        stroke: "#323232"
      }), __jsx("path", {
        id: "profile",
        d: "M15,15 C16.93375,15 18.5,13.43375 18.5,11.5 C18.5,9.56625 16.93375,8 15,8 C13.06625,8 11.5,9.56625 11.5,11.5 C11.5,13.43375 13.06625,15 15,15 L15,15 Z M15,16.75 C12.66375,16.75 8,17.9225 8,20.25 L8,22 L22,22 L22,20.25 C22,17.9225 17.33625,16.75 15,16.75 L15,16.75 Z",
        fill: "#323232"
      })))))), __jsx(ProfileBlock, null, __jsx(Name, {
        "data-hj-suppress": true
      }, "Hi ", firstName), authenticated && __jsx(Points, null, formattedPoints, " ", __jsx("span", null, "PTS ")))), this.state.showDetail && __jsx(ClickedOutside, {
        handleClickOutside: this.toggleDetail
      }, __jsx(Detail, {
        role: "dialog",
        "aria-label": "My Account"
      }, __jsx("h2", null, "Qantas Shopping account"), authorized && !authenticated ? __jsx(RememberMe, null, __jsx("div", null, __jsx("span", null, "Hi "), __jsx("b", {
        "data-hj-suppress": true
      }, firstName, ",")), __jsx("div", null, "Not you?", ' ', __jsx("a", {
        onClick: this.handleLoginClick,
        role: "link"
      }, "Log in to your account"))) : __jsx(DetailSection, {
        background: true
      }, __jsx(MemberName, {
        "data-hj-suppress": true
      }, "".concat(firstName, " ").concat(lastName)), __jsx("p", {
        "data-hj-suppress": true
      }, ffn)), __jsx(DetailSection, {
        background: true
      }, __jsx(MemberName, null, "My Account"), __jsx(LinkList, null, __jsx(LinkItem, {
        onClick: this.closeDetail
      }, __jsx(ArrowLink, {
        text: "Shopping history",
        href: "/shopping-history"
      })), __jsx(LinkItem, {
        onClick: this.closeDetail
      }, __jsx(ArrowLink, {
        text: "Manage Cards",
        href: "/manage-cards"
      })), __jsx(LinkItem, {
        onClick: this.closeDetail
      }, __jsx(ArrowLink, {
        text: "Settings",
        href: "/settings"
      })))), __jsx(LastDetails, null, __jsx(ArrowLink, {
        text: "Your Qantas profile",
        href: "https://www.qantas.com/fflyer/do/dyns/auth/yourprofile/yourProfile",
        isExternal: true
      }), authenticated && __jsx(Button, {
        outline: true,
        block: true,
        onPress: handleLogoutClick
      }, "Log out")))), __jsx("div", null, !authenticated && !authorized && __jsx(LoginButton, {
        primary: true,
        onPress: this.handleLoginClick,
        isMobileBrowser: isMobileBrowser
      }, "Log in")))), (authorized || authenticated) && __jsx(MarketingOptIn, {
        showOpt: showOptIn
      }), (authorized || authenticated) && __jsx(NewUserModal, {
        showNewUserModal: showNewUserModal
      }));
    }
  }]);
}(Component);
MemberProfile.defaultProps = memberProfileDefaultProps;
export default withMemberProfile(MemberProfile);